<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    data() {
      return {
      }
    },
    components: {
    },
    mounted() {
    },
    computed: {
      ...mapGetters({
      })
    },
    methods: {
      ...mapActions({
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Groups.vue?0adf4912